import { useEffect, useState } from 'react'
import { usePageMeta } from '@/hooks/usePageMeta'
import api from '../../services/api'
import { TeamMember } from '@/types'
import TeamMemberCard from './components/TeamMemberCard'
import './Team.css'

function Team() {
  usePageMeta({
    title: 'Notre équipe',
    description: 'Rencontrez les membres de notre équipe de campagne.',
  })

  const [members, setMembers] = useState<TeamMember[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchTeamMembers()
  }, [])

  const fetchTeamMembers = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await api.get<TeamMember[]>('/team?active=1')
      // Sort by position ascending
      const sortedMembers = data.sort((a, b) => a.position - b.position)
      setMembers(sortedMembers)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors du chargement de l\'équipe')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="team-container">
        <div className="team-header">
          <h1>Notre équipe</h1>
          <p>Rencontrez les membres de notre équipe de campagne</p>
        </div>
        <div className="team-loading">
          <div className="spinner"></div>
          <p>Chargement de l'équipe...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="team-container">
        <div className="team-header">
          <h1>Notre équipe</h1>
          <p>Rencontrez les membres de notre équipe de campagne</p>
        </div>
        <div className="team-error">
          <p>Une erreur est survenue lors du chargement de l'équipe.</p>
          <p className="error-message">{error}</p>
          <button onClick={fetchTeamMembers} className="retry-button">
            Réessayer
          </button>
        </div>
      </div>
    )
  }

  if (members.length === 0) {
    return (
      <div className="team-container">
        <div className="team-header">
          <h1>Notre équipe</h1>
          <p>Rencontrez les membres de notre équipe de campagne</p>
        </div>
        <div className="team-empty">
          <p>Aucun membre de l'équipe n'est disponible pour le moment.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="team-container">
      <div className="team-header">
        <h1>Notre équipe</h1>
        <p>Rencontrez les membres de notre équipe de campagne</p>
      </div>

      <div className="team-grid">
        {members.map((member) => (
          <TeamMemberCard key={member.id} member={member} />
        ))}
      </div>
    </div>
  )
}

export default Team
